import { wrapDisplayName } from './displayName';
import { useAsObservable } from './useAsObservable';
import { useObservable } from './useObservable';
import { createElement, Fragment, useRef, forwardRef as reactForwardRef, } from 'react';
function fromComponent(component) {
    var wrappedComponent = function (props) {
        return createElement(Fragment, null, useObservable(useRef(component(useAsObservable(props))).current));
    };
    wrappedComponent.displayName = wrapDisplayName(component, 'reactiveComponent');
    return wrappedComponent;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function fromObservable(input$) {
    return function ReactiveComponent() {
        return createElement(Fragment, null, useObservable(input$));
    };
}
export function reactiveComponent(observableOrComponent) {
    return typeof observableOrComponent === 'function'
        ? fromComponent(observableOrComponent)
        : fromObservable(observableOrComponent);
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/ban-types
export function forwardRef(component) {
    var wrappedComponent = reactForwardRef(function (props, ref) {
        return createElement(Fragment, null, useObservable(useRef(component(useAsObservable(props), ref)).current));
    });
    wrappedComponent.displayName = wrapDisplayName(component, 'reactiveComponent');
    return wrappedComponent;
}
